import React from 'react';
import {mergeClasses} from '#lib/helpers/class.js';

export default function SnapScroll(props) {
    const {as = 'ol', className, children, ...rest} = props;

    return React.createElement(
        as,
        {
            className: mergeClasses(
                'flex flex-wrap gap-3 snap-x snap-mandatory overflow-x-auto px-2 lg:px-0',
                className
            ),
            ...rest
        },
        children
    );
}

function Item(props) {
    const {as = 'li', className, children, ...rest} = props;
    return React.createElement(
        as,
        {className: mergeClasses('flex-shrink-0 snap-start', className), ...rest},
        children
    );
}

SnapScroll.Item = Item;
